export default "__VITE_ASSET__CMpwOVEh__"